import * as React from 'react'

import * as LabelPrimitive from '@radix-ui/react-label'

import { cn } from '@/infra'

const Label = ({ className, ...props }: React.ComponentProps<typeof LabelPrimitive.Root>) => {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn('flex items-center gap-2', 'form-label', className)}
      {...props}
    />
  )
}

export { Label }
